<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theMtmId' clearable placeholder="请输入微课主分类" size='small' style="max-width:200px;"
          @change="theMtmIdChange">
          <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId" :label="item.mtmName"
            :value="item.mtmId"></el-option>
        </el-select>
        <el-select v-model='theMtId' clearable placeholder="选择分类" size="small" @change="theMtIdChange">
          <el-option v-for="item in getMicrolectureTypeList_data.data || []" :key="item.mtId" :label="item.mtName"
            :value="item.mtId">
          </el-option>
        </el-select>
        
        <el-select v-model='microlectureType' clearable placeholder="选择微课基础类型" size="small"
          @change="theMicrolectureTypeChange">
          <el-option label="常规" :value="1"></el-option>
          <el-option label="智能树类型" :value="2"></el-option>
        </el-select>
        <el-select v-model='theMicrolectureStatus' clearable placeholder="选择微课状态" size="small"
          @change="theMicrolectureStatusChange">
          <el-option label="待发布" :value="1"></el-option>
          <el-option label="已发布" :value="2"></el-option>
          <el-option label="下架" :value="3"></el-option>
        </el-select>
        <el-cascader ref='cascader' v-model="getMicrolectureList_data.srId" clearable filterable size='small'
          placeholder='请选择区域' :show-all-levels='false'
          :options="getSysRegionList_data ? getSysRegionList_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'srName', value: 'srId', children: 'children' }"
          @change="$refs.cascader.dropDownVisible = false">
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{ data.srName }}</span>
          </template>
        </el-cascader>
        <el-input v-model="getMicrolectureList_data.microlectureTitle" placeholder="请输入微课名" clearable size='small'
          style="max-width:200px;" />
        <el-button v-click.getMicrolectureList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>
      <el-col :span="6">
        <el-button v-if="addMicrolecture" @click="$form('addMicrolecture'), getMicrolectureTypeList({ pageSize: 0 })"
          size='small' type="primary" style="float:right" icon='el-icon-circle-plus'>添加微课
        </el-button>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getMicrolectureList' api='getMicrolectureList' xupdateapi='updateMicrolecture'
      :height="H - 165">
      <icol slot='microlectureCover' :showtooltip='false' img='microlectureCover' />
      <icol slot='microlecturePicture' :showtooltip='false' img='microlecturePicture' />
    </mytable>

    <myform :viewobj='{
        addMicrolecture: ["新增微课信息", "el-icon-circle-plus"],
        updateMicrolecture: ["修改微课信息", "el-icon-edit-outline"],
        $succeed$: getMicrolectureList
      }' @closed="
        $form('updateMicrolecture', 'reset');
      window.sleep(50, v => Myformdata && (Myformdata.microlectureCover = Myformdata.microlecturePath = '', VideoArr = VideoArr2))
        " @confirm='myform'>
      <hide slot='microlectureId' />
      <template v-slot:mtId="{ Myformdata }">
        <el-select v-model='theMtmId2' clearable placeholder="请输入微课主分类"  style="max-width:200px;"
          @change="theMtmIdChange2">
          <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId" :label="item.mtmName"
            :value="item.mtmId"></el-option>
        </el-select>
        <el-select v-model='Myformdata.mtId' clearable>
          <el-option v-for="item in getMicrolectureTypeList_data.data || []" :key="item.mtId" :label="item.mtName"
            :value="item.mtId">
          </el-option>
        </el-select>
      </template>
      <template v-slot:microlectureType="{ Myformdata }">
        <el-select v-model='Myformdata.microlectureType' clearable>
          <el-option label="常规" :value="1"></el-option>
          <el-option label="智能树" :value="2"></el-option>
        </el-select>
      </template>
      <template v-slot:microlectureOrder="{ Myformdata }">
        <el-input v-model='Myformdata.microlectureOrder' placeholder="请输入排序" type="number"></el-input>
      </template>
      <template v-slot:microlectureDes="{ Myformdata }">
        <el-input :rows="3" v-model='Myformdata.microlectureDes' type="textarea" placeholder="请输入产品描述"></el-input>
      </template>
      <!-- <template v-slot:microlectureCover="{Myformdata}" >
        <el-image :src="Myformdata.microlectureCover" fit="cover" lazy></el-image>
  	  </template> -->
      <template v-slot:microlectureCover='{ Myformdata }'>
        <myupload v-event.fileUpload='`
                      return (Myformdata.microlectureCover+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.microlectureCover = C : false )
                    `' @change='Myformdata.microlectureCover = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.microlectureCover = "")' type='image' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.microlectureCover && Myformdata.microlectureCover != ' '
        ? ({ name: Myformdata.microlectureCover, url: Myformdata.microlectureCover })
        : false"
          :style="{ height: Myformdata.microlectureCover && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:microlecturePicture='{ Myformdata }'>
        <myupload v-event.fileUpload='`
                      return (Myformdata.microlecturePicture+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.microlecturePicture = C : false )
                    `' @change='Myformdata.microlecturePicture = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.microlecturePicture = "")' type='image' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.microlecturePicture && Myformdata.microlecturePicture != ' '
        ? ({ name: Myformdata.microlecturePicture, url: Myformdata.microlecturePicture })
        : false"
          :style="{ height: Myformdata.microlecturePicture && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:microlecturePictureScript='{ Myformdata }'>
        <myupload v-event.fileUpload='`
                      return (Myformdata.microlecturePictureScript+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.microlecturePictureScript = C : false )
                    `' @change='Myformdata.microlecturePictureScript = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.microlecturePictureScript = "")' type='image' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.microlecturePictureScript && Myformdata.microlecturePictureScript != ' '
        ? ({ name: Myformdata.microlecturePictureScript, url: Myformdata.microlecturePictureScript })
        : false
        "
          :style="{ height: Myformdata.microlecturePictureScript && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:microlecturePictureScriptSecret='{ Myformdata }'>
        <myupload v-event.fileUpload='`
                      return (Myformdata.microlecturePictureScriptSecret+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.microlecturePictureScriptSecret = C : false )
                    `' @change='Myformdata.microlecturePictureScriptSecret = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.microlecturePictureScriptSecret = "")' type='image' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.microlecturePictureScriptSecret && Myformdata.microlecturePictureScriptSecret != ' '
        ? ({ name: Myformdata.microlecturePictureScriptSecret, url: Myformdata.microlecturePictureScriptSecret })
        : false
        "
          :style="{ height: Myformdata.microlecturePictureScriptSecret && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:microlecturePath='{ Myformdata }'>
        <myupload v-event.fileUpload='`
                      return (Myformdata.microlecturePath+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.microlecturePath = C : false )
            `' @change='Myformdata.microlecturePath = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.microlecturePath = "")' type='video' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.microlecturePath && Myformdata.microlecturePath != ' '
        ? ({ name: Myformdata.microlecturePath, url: Myformdata.microlecturePath })
        : false
        " videoStyle="max-height:300px;" x:style="{height: $form('updateMicrolecture','ifshow') ? '250px' : ''}">
        </myupload>

      </template>

      <template v-slot:microlectureParagraphListString="{ Myformdata }">
        <el-button @click="addweike" size='small' type="primary" icon='el-icon-circle-plus'>添加微课段落
        </el-button>
        <div v-for="(item, index) in VideoArr || []" :key="index">
          <el-button @click="delweile(index)" size='small' type="primary" icon='el-icon-circle-plus'>删除微课段落
          </el-button>
          <el-form-item label="提问视频" label-width="100">
            <myupload v-event.fileUpload='`
           
                          return (VideoArr[${index}].ympVideo+"").startsWith("http") 
                                        || ( (C = (await C.MyUpload()).file) ? VideoArr[${index}].ympVideo = C : false )
            `' @change='item.ympVideo = ($file$ = arguments[0]).url'
              @remove='window.sleep(150, v => item.ympVideo = "")' type='video' :limit='1' :params='{ file: "$file$" }'
              :filelist="item.ympVideo && item.ympVideo != ' '
        ? ({ name: item.ympVideo, url: item.ympVideo })
        : false
        " videoStyle="max-height:300px;" x:style="{height: $form('updateMicrolecture','ifshow') ? '250px' : ''}">
            </myupload>
          </el-form-item>
          <el-form-item label="回答内容" label-width="100">
            <el-input v-model="item.ympContent" style="width: 80%;" size="small"></el-input>
          </el-form-item>
          <el-form-item label="关键词" label-width="100">
            <el-input v-model="item.ympKeyword" style="width: 80%;" size="small"></el-input>
          </el-form-item>
          <el-form-item label="排序" label-width="100">
            <el-input v-model="item.ympOrder" style="width: 80%;" size="small"></el-input>
          </el-form-item>
        </div>

      </template>
      <template v-slot:srId="{ Myformdata }">
        <el-cascader ref='cascader' v-model="Myformdata.srId" clearable filterable size='small' placeholder='请选择区域'
          :show-all-levels='false' :options="getSysRegionList_data ? getSysRegionList_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'srName', value: 'srId', children: 'children' }"
          @change="$refs.cascader.dropDownVisible = false">
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{ data.srName }}</span>
          </template>
        </el-cascader>
      </template>
      <!-- <template v-slot:microlecturePath="{Myformdata}" >
        <video :src="Myformdata.microlecturePath" controls class="video" :ref="dialogVideo"/>
  	  </template> -->
    </myform>
    <el-dialog title="选择" :visible.sync="isVideoBank" width="40%">
      <el-radio-group v-model="VideoBankRadio">
        <el-radio :label="1">视频库选择微课段落</el-radio>
        <el-radio :label="2">新增微课段落信息</el-radio>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="bulkAdditionsClose">取 消</el-button> -->
        <el-button type="primary" @click="SureVideo">确定</el-button>
      </div>
    </el-dialog>
    <myform :viewobj='{
        addMicrolectureParagraph: ["新增微课段落信息", "el-icon-circle-plus"],
        updateMicrolectureParagraph: ["修改微课段落信息", "el-icon-edit-outline"],
      }' @closed="$form('updateMicrolectureParagraph', 'reset');
      window.sleep(50, v => Myformdata && getList())" @confirm='myforms'>
      <hide slot='ympParentId' />
      <hide slot='microlectureId' />
      <hide slot='ympId' />
      <hide slot='ymwId' />
      <hide slot='ymwIds' />
      <template v-slot:ympType="{ Myformdata }">
        <el-select v-model='Myformdata.ympType' clearable>
          <el-option label="常规" :value="1"></el-option>
          <el-option label="多选问答" :value="2"></el-option>
        </el-select>
      </template>
      <template v-slot:ympContentType="{ Myformdata }">
        <el-select v-model='Myformdata.ympContentType' clearable>
          <el-option label="没有答案" :value="1"></el-option>
          <el-option label="单一答案" :value="2"></el-option>
          <el-option label="多种答案" :value="3"></el-option>
        </el-select>
      </template>
      <template v-slot:ympVideo='{ Myformdata }'>
        <myupload v-event.fileUpload='`
                      return (Myformdata.ympVideo+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.ympVideo = C : false )
            `' @change='Myformdata.ympVideo = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.ympVideo = "")' type='video' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.ympVideo && Myformdata.ympVideo != ' '
        ? ({ name: Myformdata.ympVideo, url: Myformdata.ympVideo })
        : false
        " videoStyle="max-height:300px;" x:style="{height: $form('updateMicrolecture','ifshow') ? '250px' : ''}">
        </myupload>

      </template>
      <template v-slot:ympVideoMore='{ Myformdata }'>
        <myupload v-event.fileUpload='`
                      return (Myformdata.ympVideoMore+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.ympVideoMore = C : false )
            `' @change='Myformdata.ympVideoMore = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.ympVideoMore = "")' type='video' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.ympVideoMore && Myformdata.ympVideoMore != ' '
        ? ({ name: Myformdata.ympVideoMore, url: Myformdata.ympVideoMore })
        : false
        " videoStyle="max-height:300px;" x:style="{height: $form('updateMicrolecture','ifshow') ? '250px' : ''}">
        </myupload>

      </template>
      <template v-slot:ympContent="{ Myformdata }">
        <el-input v-model='Myformdata.ympContent' type="textarea" :rows="4"
          placeholder="请输入内容(多选问答以&&&隔开)(如果一个问题多个答案也以&&&隔开)"></el-input>
      </template>
    </myform>
    <myform :viewobj='{
        addMicrolectureParagraph2: ["新增微课段落信息", "el-icon-circle-plus"],
        updateMicrolectureParagraph2: ["修改微课段落信息", "el-icon-edit-outline"],
      }' @closed="$form('updateMicrolectureParagraph', 'reset');
      window.sleep(50, v => Myformdata && getList())" @confirm='myforms'>
      <template v-slot:ymwIds="{ Myformdata }">
        <el-select v-model='Myformdata.ymwIds' clearable multiple filterable>
          <el-option v-for="item in getMicrolectureWareList_data.data || []" :key="item.ymwId" :label="item.ymwCode"
            :value="item.ymwId">
          </el-option>
        </el-select>
      </template>
      <template v-slot:ymwId="{ Myformdata }">
        <el-select v-model='Myformdata.ymwId' clearable filterable>
          <el-option v-for="item in getMicrolectureWareList_data.data || []" :key="item.ymwId" :label="item.ymwCode"
            :value="item.ymwId">
          </el-option>
        </el-select>
      </template>
      <hide slot='ympParentId' />
      <hide slot='microlectureId' />
      <hide slot='ympId' />
    </myform>
    <myform :viewobj='{
        addMicrolectureParagraphCopy: ["复制微课段落", "el-icon-edit-outline"],
      }' @closed="$form('updateMicrolectureParagraph', 'reset');
      window.sleep(50, v => Myformdata && getList())" @confirm='myformCopy' width="90%">
      <template v-slot:microlectureId="{ Myformdata }">
        <div>
          <el-select v-model='microlectureId' clearable placeholder="选择微课" size="small"
            @change="themicrolectureIdChange" style="width: 400px;">
            <el-option v-for="item in weikeList || []" :key="item.microlectureId" :label="item.microlectureTitle"
              :value="item.microlectureId">
            </el-option>
          </el-select>
        </div>
      </template>

      <template v-slot:ympIdCopy="{ Myformdata }">

        <el-tree :data="TreeWeikeArrCopy" node-key="ympId" check-strictly default-expand-all expand-on-click-node
          show-checkbox @check-change="handleCheckChange" @check="CheckChange" :props="defaultProps" ref="treeCopy">
          <div class="custom-tree-node" slot-scope="{ node, data }"
            style="display: flex;justify-content: space-between;align-items: center;position: relative;width: 100%;">
            <el-popover placement="top-start" width="500" trigger="focus" :content="node.label">
              <div slot="reference"
                style="width: 500px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: black;font-size: 16px;margin: 10px 0;">
                {{ node.label }}</div>
            </el-popover>
          </div>
        </el-tree>
      </template>
      <hide slot='ympId' />
    </myform>
    <el-dialog title="详情" :visible.sync="viedoDet" width="60%" :before-close="DeailClose">
      <div>
        <el-button v-if="addMicrolectureParagraph" @click="$form('addMicrolectureParagraph')" size='small'
          type="primary" style="float:right" icon='el-icon-circle-plus'>添加微课段落
        </el-button>
      </div>

      <el-table v-if="detailArr" :data="detailArr || []" border highlight-current-row :header-cell-style="{
        textAlign: 'center',
        background: 'rgba(0,170,255,0.5)',
        color: 'black',
        border: 'none'
      }" style="width: 100%;margin:12px 0 0 0;">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column prop="ympContent" label="回答内容"> </el-table-column>
        <el-table-column prop="ympKeyword" label="关键词"> </el-table-column>

        <el-table-column prop="ympOrder" label="排序"> </el-table-column>
        <el-table-column prop="ympVideo" label="提问视频">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="Preview(scope.row.ympVideo)">预览
            </el-button>
            <el-button size="mini" type="text" style="color: green;"
              @click='$form("updateMicrolectureParagraph", scope.row)'>编辑
            </el-button>
            <el-button size="mini" type="text" style="color: red;" @click="delDeatl(scope.row.ympId)">删除
            </el-button>
          </template>
        </el-table-column>

      </el-table>

    </el-dialog>
    <el-dialog title="段落详情" :visible.sync="isParagraph" width="80%" :before-close="isParagraphClose">
      <el-descriptions v-if="ParagraphDetail" :column="2" border :labelStyle="{
        color: '#409EFF',
        textAlign: 'center',
        width: '20%',
        fontSize: '12px'
      }" :contentStyle="{ textAlign: 'left', width: '30%', fontSize: '12px' }">
        <el-descriptions-item label="段落编码">{{ ParagraphDetail.ymwCode }}</el-descriptions-item>
        <el-descriptions-item label="段落类型">{{ ParagraphDetail.ympType == 1 ? '常规' : '多选问答' }}</el-descriptions-item>
        <el-descriptions-item label="多选问答匹配度">{{ ParagraphDetail.ympTypeTwoPass }}</el-descriptions-item>
        <el-descriptions-item label="没有听懂通过匹配度">{{ ParagraphDetail.ympTypeThreePass }}</el-descriptions-item>
        <el-descriptions-item label="没有听懂段落编码">{{ ParagraphDetail.ympThreeCode }}</el-descriptions-item>
        <el-descriptions-item label="排序">{{ ParagraphDetail.ympOrder }}</el-descriptions-item>
        <el-descriptions-item label="问题">{{ ParagraphDetail.ympQuestion }}</el-descriptions-item>
        <el-descriptions-item label="视频路径">
          <video width="250" height="150" controls v-if="ParagraphDetail.ympVideo" :src="ParagraphDetail.ympVideo">
            <!-- <source :src="ParagraphDetail.ympVideo" type="video/mp4"> -->
            <!-- 您的浏览器不支持视频标签。 -->
          </video>
        </el-descriptions-item>
        <el-descriptions-item label="多选问答需要的旁白">
          <video width="250" height="150" controls v-if="ParagraphDetail.ympVideoMore"  :src="ParagraphDetail.ympVideoMore">
          </video>
        </el-descriptions-item>
        <el-descriptions-item label="答案类型">{{ ParagraphDetail.ympContentType == 1 ? '没有答案' :
        ParagraphDetail.ympContentType
          ==
          2 ? '单一答案' : '多种问答' }}</el-descriptions-item>
        <el-descriptions-item label="内容">{{ ParagraphDetail.ympContent }}</el-descriptions-item>
        <el-descriptions-item label="内容视频">
          <video width="250" height="150" controls v-if="ParagraphDetail.ympContentVideo" :src="ParagraphDetail.ympContentVideo">
          </video>
        </el-descriptions-item>
        <el-descriptions-item label="关键词">{{ ParagraphDetail.ympKeyword }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog title="详情(鼠标长按可以显示段落详情)" :visible.sync="isTree" width="90%" :before-close="DeailClose">
      <div style="height: 30px;display:flex;flex-direction: row-reverse">
        <el-button @click="isVideoBankClick()" size='mini' type="primary" icon='el-icon-circle-plus'>添加微课段落
        </el-button>
        <el-button 
          @click=" $form('uploadMicrolectureParagraphExcel'), tabledataAll = [], row = {}" size='mini' type="primary"
          style="margin-right: 20px;" icon='el-icon-circle-plus'>批量导入段落
        </el-button>
      </div>
      <div style="height: 600px;overflow-y: auto;">
        <el-tree :data="TreeWeikeArr" node-key="ympId" default-expand-all :expand-on-click-node="false"
          :props="defaultProps" highlight-current>
          <div class="custom-tree-node" slot-scope="{ node, data }" style="display: flex;justify-content: space-between;align-items: center;position: relative;width: 100%;
             border: 1px solid #409EFF;margin: 10px 0;padding: 0 10px;">
            <el-popover placement="top-start" width="500" trigger="focus" :content="node.label">
              <div slot="reference"
                style="width: 500px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: black;font-size: 16px;margin: 10px 0;">
                <span v-if="data.ymwCode"> {{ data.ymwCode }}</span>
                <span v-if="node.label"> {{ node.label }}</span>
              </div>
            </el-popover>
            <div style="position: absolute;right: 20px;top: 10px;">
              <el-button type="text" size="mini" @click="() => addCopy(data)">
                复制微课段落
              </el-button>
              <el-button type="text" size="mini" @click="() => isVideoBankClick(data)">
                新增微课子段落
              </el-button>
              <el-button type="text" size="mini" style="color: black;" @click="() => ParagraphDetails(data)">
                详情
              </el-button>
              <el-button type="text" size="mini" style="color: green;" @click="() => WeikeparagraphUpdata(data)">
                编辑
              </el-button>
              <el-button type="text" size="mini" style="color: red;" @click="() => delDeatl(data.ympId)">
                删除
              </el-button>
            </div>
          </div>
        </el-tree>

      </div>
    </el-dialog>
    <myform view.uploadMicrolectureParagraphExcel="批量导入" @close='$form("uploadMicrolectureParagraphExcel", "hide")'>
      <el-row>
        <el-col :span="4" style="min-width:100px;">
          <el-button type="primary" @click="toDownExcel">下载<i class="el-icon-download el-icon--right"></i></el-button>
        </el-col>
        <el-col :span="20">
          <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
            :on-change="onChangeContent">
            <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </el-upload>
        </el-col>
      </el-row>
    </myform>
  </div>
</template>

<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      theMtmId2:'',
      ParagraphDetail: '',
      isParagraph: false,
      tabledata: [],
      tabledataAll: [],
      theMicrolectureStatus: '',
      VideoBankRadio: 1,
      isVideoBank: false,
      getMicrolectureTypeMainList_data: [],
      theMtmId: '',
      weikeList: [],
      TreeWeikeArrCopy: '',
      currentNodeKey: '',//当前选择的节点
      microlectureType: '',
      defaultProps: {
        label: 'ympContent',
        id: 'ympId'
      },
      Weikeparagraph: null,//微课段落
      ympParentId: 0,
      isTree: false,
      TreeWeikeArr: [],
      theProjectId: 0,
      deatilObj: '',
      VideoArr2: [
        {
          ympId: '',
          microlectureId: '',
          ympVideo: '',
          ympContent: '',
          ympKeyword: '',
          ympOrder: '',
        }
      ],
      VideoArr: [
        {
          ympId: '',
          microlectureId: '',
          ympVideo: '',
          ympContent: '',
          ympKeyword: '',
          ympOrder: '',
        }
      ],
      detailArr: [],
      microlectureId: null,
      theMtId: "",
      viedoDet: false,
      tableColums_getMicrolectureList: {
        $selection: false,

        microlectureTitle: '标题',

        microlectureCover: '封面',
        microlectureType: ['微课基础类型', , '@v-if: 1:常规 #(--Themecolor), 2:智能树 #danger+'],
        srName: '区域',
        // microlecturePicture: '介绍图片',

        // microlectureDes: '产品描述',

        microlectureLookNum: '观看数',

        microlectureZanNum: '点赞数',

        microlectureOrder: '排序',
        microlectureStatus: ['状态', , '@v-if: 1:待发布#danger, 2:已发布#success,3:下架#danger+'],
        createtime: '创建时间',

        qpName: '关联试卷',

        $operation: [
          '操作', 200,
          `@text: 详情#success
           @click:handelDetail($row) 
          `,
          this.updateMicrolecture && `@text: 编辑#warn
           @click: handelEdit($row)  
          `,
          this.deleteMicrolecture && `@text: 删除#danger
           @click: _confirm('确定要删除该微课吗?')
                   .trigger('deleteMicrolecture',{microlectureId:$row.microlectureId})
                   .trigger('getMicrolectureList')
          `,
          this.updateMicrolectureUp && `@text: 上架#success
           @click: _confirm('确定要上架该微课吗?')
                   .trigger('updateMicrolectureUp',{microlectureId:$row.microlectureId})
                   .trigger('getMicrolectureList')
          `,
          this.updateMicrolectureDown && `@text: 下架#danger
           @click: _confirm('确定要下架该微课吗?')
                   .trigger('updateMicrolectureDown',{microlectureId:$row.microlectureId})
                   .trigger('getMicrolectureList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    ParagraphDetails(data) {
      this.getMicrolectureParagraphDetails({ ympId: data.ympId }).result(res => {
        if (res.data.data) {
          this.ParagraphDetail = res.data.data;
          this.isParagraph = true;
        }
      })
    },
    isParagraphClose() {
      this.isParagraph = false;
    },
    bulkImportClick() {
      // if (this.tabledata.sitId == '') {
      //   this.$message({
      //     showClose: true,
      //     message: "请导入资料",
      //     type: 'danger'
      //   });
      // } else {
      //   this.uploadImportVisitorCompany({
      //     sitId: this.tabledata.sitId
      //   })
      //   this.$message({
      //     type: 'success',
      //     message: '导入成功!'
      //   });
      //   this.$form("uploadMicrolectureParagraphExcel", "hide")
      // }

    },
    toDownExcel() {
      myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/uploadMicrolectureParagraphExcel.xlsx", "uploadMicrolectureParagraphExcel.xlsx");
    },
    doupload: async function (file) {
      let param = new FormData(); // 创建form对象
      param.append("file", file);
      param.append("microlectureId", this.deatilObj.microlectureId);// 通过append向form对象添加数据
      if (this.row && this.row.projectId) {
        param.append("projectId", this.row.projectId);
      }
      console.log(param)
      const loading = $Loading();
      const responseData = await myhttp.postFileUsers("/opportunity/microlecture-paragraph/uploadMicrolectureParagraphExcel", param);
      loading.close();
      if (responseData.data.result == "success") {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
        this.$form("uploadMicrolectureParagraphExcel", "hide");
        this.getList()
      } else {
        this.$message({
          type: "error",
          message: responseData.data.msg
        });
      }
      return responseData
    },
    async onChangeContent(files, fileList) {
      const table = await this.doupload(files.raw);
      // this.tabledata = table.data.data.data.sysImportTem;
      // this.tabledataAll = table.data.data.data.resultList;
      //    this.getUserTargetList();
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();  //清空文件
      }
      if (this.$refs.uploadAll) {
        this.$refs.uploadAll.clearFiles();  //清空文件
      }
    },
    WeikeparagraphUpdata(data) {
      if (data.ymwId) {
        this.VideoBankRadio = 1
        this.$form('updateMicrolectureParagraph2', data)
      } else {
        this.VideoBankRadio = 2
        this.$form('updateMicrolectureParagraph', data)
      }
    },
    isVideoBankClick(val) {
      this.Weikeparagraph = val;
      this.VideoBankRadio = 1;
      this.SureVideo()

    },
    // 选择新增或者编辑微课段落格式
    SureVideo() {
      if (this.VideoBankRadio == 1) {
        this.isVideoBank = false;
        this.$form('addMicrolectureParagraph2')
      } else {
        this.isVideoBank = false;
        this.$form('addMicrolectureParagraph')
      }
    },
    themicrolectureIdChange(e) {
      this.microlectureId = e
      this.getMicrolectureParagraphList({ microlectureId: e }).result(res => {
        this.TreeWeikeArrCopy = res.data.data;
        this.currentNodeKey = '';
      })
    },
    addCopy(data) {
      this.getMicrolectureListAll({ microlectureType: 2, pageSize: 0 }).result(res => {
        this.microlectureId = data.microlectureId;
        this.weikeList = res.data.data;
        this.TreeWeikeArrCopy = this.TreeWeikeArr
        this.currentNodeKey = '';
        this.Weikeparagraph = data;
        this.$form('addMicrolectureParagraphCopy');
      })

    },
    CheckChange(data, v) {
      console.log(data, v);
      if (this.currentNodeKey && this.$refs.treeCopy) {
        this.$refs.treeCopy.setCheckedKeys([])
        this.$refs.treeCopy.setCheckedNodes([data])
      }
      this.Myformdata.ympIdCopy = this.currentNodeKey = data.ympId;
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    myformCopy(submit, Myformdata) {
      Myformdata.ympId = this.Weikeparagraph.ympId
      submit();
    },
    shuju(node, data) {
      console.log(node, data);
    },
    delDeatl(id) {
      this.deleteMicrolectureParagraph({ ympId: id }).result(res => {
        if (res.data) {
          this.getList()
        }
      })
    },
    Preview(url) {
      document.PreviewVideo(url)
    },
    DeailClose() {
      this.Weikeparagraph = null;
      this.detailArr = [];
      this.TreeWeikeArr = []
      this.viedoDet = false;
      this.isTree = false;
    },
    handelDetail(row) {
      this.getMicrolectureDetails({ microlectureId: row.microlectureId }).result((res) => {
        console.log(res);
        if (res.data.data) {
          const obj = res.data.data
          this.deatilObj = res.data.data;
          if (res.data.data.microlectureType == 1) {
            this.detailArr = obj.microlectureParagraphList;
            this.viedoDet = true;
          } else {
            console.log(this.Myformdata);
            this.TreeWeikeArr = obj.microlectureParagraphList;
            this.isTree = true;
          }

        }
      });


    },
    async handelEdit(row) {
      this.getMicrolectureDetails({ microlectureId: row.microlectureId }).result((res) => {
        console.log(res);
        if (res.data.data) {
          const obj = res.data.data
          this.VideoArr = obj.microlectureParagraphList;
          console.log(obj);
          this.$form("updateMicrolecture", obj), this.getMicrolectureTypeList({ pageSize: 0 })
        }
      });

      //
    },
    sub(submit) {
      const list = this.VideoArr
      this.Myformdata.microlectureParagraphListString = JSON.stringify(list);
      console.log(this.Myformdata);
      submit();
      this.VideoArr = [
        {
          ympId: '',
          microlectureId: '',
          ympVideo: '',
          ympContent: '',
          ympKeyword: '',
          ympOrder: '',
        }
      ]
    },
    getList() {
      this.getMicrolectureParagraphList({ microlectureId: this.deatilObj.microlectureId }).result(res => {
        this.detailArr = res.data.data;
        this.TreeWeikeArr = res.data.data;
      })
    },
    async myform(submit, Myformdata) {
      const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))
    },
    async subs(submit) {
      console.log(this.Myformdata, this.deatilObj);
      this.Myformdata.ymwIds = this.Myformdata.ymwIds ? this.Myformdata.ymwIds.toString() : null;
      this.Myformdata.microlectureId = this.deatilObj.microlectureId;
      this.Myformdata.ympParentId = this.Weikeparagraph ? this.Weikeparagraph.ympId : 0;
      this.$nextTick(() => {

      })
      submit();
    },
    async myforms(submit, Myformdata) {
      if (this.VideoBankRadio == 1) {
        this.subs(submit)
      } else {
        const res = await this.$trigger("fileUpload").trigger(res => res && this.subs(submit))
      }

    },
    delweile(index) {
      if (this.VideoArr.length == 1) {
        return;
      }
      this.VideoArr.splice(index, 1);
    },
    addweike() {

      this.VideoArr.push({
        ympId: '',
        microlectureId: '',
        ympVideo: '',
        ympContent: '',
        ympKeyword: '',
        ympOrder: '',
      })


    },
    theMicrolectureStatusChange(e) {
      this.theMicrolectureStatus = e;
      this.getMicrolectureList({ microlectureStatus: this.theMicrolectureStatus, mtmId: this.theMtmId, microlectureType: this.microlectureType, mtId: this.theMtId, srId: this.getMicrolectureList_data.srId, microlectureTitle: this.getMicrolectureList_data.microlectureTitle });
    },
    theMtmIdChange(e) {
      this.theMtmId = e;
      this.getMicrolectureTypeList({mtmId:e})
      this.getMicrolectureList({ microlectureStatus: this.theMicrolectureStatus, mtmId: this.theMtmId, microlectureType: this.microlectureType, mtId: this.theMtId, srId: this.getMicrolectureList_data.srId, microlectureTitle: this.getMicrolectureList_data.microlectureTitle });
    },
    theMtmIdChange2(e) {
      this.getMicrolectureTypeList({mtmId:e})
    },
    theMicrolectureTypeChange(e) {
      this.microlectureType = e;
      this.getMicrolectureList({ microlectureStatus: this.theMicrolectureStatus, mtmId: this.theMtmId, microlectureType: this.microlectureType, mtId: this.theMtId, srId: this.getMicrolectureList_data.srId, microlectureTitle: this.getMicrolectureList_data.microlectureTitle });
    },
    theMtIdChange(e) {
      this.theMtId = e;
      this.getMicrolectureList({ microlectureStatus: this.theMicrolectureStatus, mtmId: this.theMtmId, microlectureType: this.microlectureType, mtId: this.theMtId, srId: this.getMicrolectureList_data.srId, microlectureTitle: this.getMicrolectureList_data.microlectureTitle });
    }
  },

  created() {
    this.getMicrolectureList({ mtId: this.theMtId });
    this.getMicrolectureTypeList({ pageSize: 0 });
    this.getMicrolectureWareList({ pageSize: 0 });
    this.getSysRegionList()
    this.getMicrolectureTypeMainLists().result((res) => {
      if (res.data.data) {
        console.log(res.data.data);
        this.getMicrolectureTypeMainList_data = res.data.data
      }
    })
  }
};
</script>

<style scoped>
div /deep/ .el-tree-node__content {
  height: 55px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/help/MicrolectureManage.vue